import { IonSpinner } from "@ionic/react";
import { showToaster } from "global/context/action/toaster/toaster";
import { GlobalContext } from "global/context/Provider";
import { useContext, useEffect, useState } from "react";
import MercadoPagoLogo from "_+_Portal/assets/images/generico/MercadoPagoLogo";
import {
  mercadoPagoReset,
  wsGetMercadoPagoLaboratorioQr,
  wsGetMercadoPagoTurnosQr,
} from "_+_Portal/context/Actions/mercadoPago/mercadoPago";
import { PortalContext } from "_+_Portal/context/Provider";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import PasoBar from "_+_Portal/_-_Autocheckin/components/genericos/PasoBar/PasoBar";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  Paso4Body,
  Paso4Container,
  Paso4ContainerBotones,
  Paso4ContainerPaso,
  Paso4Titulo,
} from "./localStyle";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { proximoPaso } from "../PagesFun";
import { setRuta } from "_+_Portal/_-_Autocheckin/context/action/ruta";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { wsGetTurnosPacienteDelDiaQr } from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";

import { setAvisoAutocheck } from "_+_Portal/_-_Autocheckin/context/action/avisoAutocheck";
import { useHistory } from "react-router";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";
import {
  wsGetTurnoSaldado,
  wsGetTurnoSaldadoLabo,
} from "_+_Portal/context/Actions/turnos/turnoSaldado";
import { getLocalStorage } from "global/utils/safeJsonParse";

const AbonarMP = ({ turnoActual }) => {
  //#region --------- context ---------------
  const {
    turnosSeleccionadosState,
    pasoDispatch,
    rutaDispatch,
    puntoControlDispatch,
    rutaState,
    turnosAutoCheckInDispatch,
    avisoAutocheckDispatch,
    turnosSeleccionadosDispatch,
    turnoSaldadoDispatch,
    pasoState,
  } = useContext(AutocheckContext);
  const { mercadoPagoDispatch, mercadoPagoState, selectDropDownState } =
    useContext(PortalContext);
  const { toasterDispatch, authState } = useContext(GlobalContext);
  const history = useHistory();
  const idTerminal = getLocalStorage("idTerminal");
  //#endregion  ----- context ---------------
  //#region  ----------- constants ---------------

  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados?.data ?? [];
  const turno = listTurnosSeleccionado[turnoActual];

  const bodyTxt =
    "Te falta un paso para finalizar la recepción de tu turno. El valor del mismo es de:";
  const bodyTxt2 =
    "(Seleccioná una opción para abonar. Recordá que por Mercadopago podés abonar con tarjeta de crédito y/o débito)";

  const [loadingGral, setLoadingGral] = useState(true);
  const [loading, setLoading] = useState(false);
  const [intervalID, setIntervalID] = useState(true);
  const [mpReferencia, setMpReferencia] = useState(null);
  // Espera a tener la ref
  //#endregion --------- constants ---------------
  //#region  ----------- funciones ---------------
  const nextStepMercadoPago = (isCorrect, data) => {
    if (isCorrect) {
      setMpReferencia(JSON.parse(data.idWebservice));
    } else {
      showToaster(
        {
          texto: "Hubo un error al obtener link de MP.",
          tipo: "danger",
        },
        "centroArriba",
      )(toasterDispatch);
      const idTipoPuntoControl = 8;
      setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
      setPaso("PuntoControl")(pasoDispatch);
    }
  };

  const handleClickMP = () => {
    if (idTerminal) {
      setPaso("MercadoPagoQRDesktop")(pasoDispatch);
    } else {
      setLoading(true);
      window.open(mpReferencia?.initPoint, "_blank");
    }
  };

  const refrescarTurnos = (isCorrect, data) => {
    if (!mountedRef.current) return;
    if (isCorrect && data) {
      const turnosActualizados = actualizarTurnos(listTurnosSeleccionado, data);
      setTurnosSeleccionado(turnosActualizados)(turnosSeleccionadosDispatch);
      setLoadingGral(false);
    } else {
      setLoadingGral(false);
    }
  };

  const actualizarTurnos = (turnosLocal, turnosWs) => {
    return turnosLocal.map((turnoLocal) => {
      const turnoWs = turnosWs.find((t) => t.idturno === turnoLocal.idturno);
      if (turnoWs) {
        return { ...turnoLocal, ...turnoWs };
      }
      return turnoLocal;
    });
  };

  const irPuntoDeControl = () => {
    setLoading(true);
    const idTipoPuntoControl = 8;
    setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
    setPaso("PuntoControl")(pasoDispatch);
  };

  let loopTurnoSaldado = () => {
    let count = 0;
    setLoading(true);
    let interval = setInterval(() => {
      let stopLoopTurnoSaldado = (isCorrect, flgSaldada) => {
        if (isCorrect && flgSaldada) {
          clearInterval(interval);
          setLoading(false);
          if (pasoState.circuito === "labo") {
            setPaso("CierreRecepcionLabo")(pasoDispatch);
          } else {
            const ruta = rutaState.ruta.data;
            setRuta(proximoPaso(ruta, setPaso, pasoDispatch))(rutaDispatch);
          }
        } else if (!isCorrect) {
          clearInterval(interval);
          irPuntoDeControl();
        }
      };
      if (pasoState.circuito === "labo") {
        wsGetTurnoSaldadoLabo(
          turno.idProtocolo,
          stopLoopTurnoSaldado,
        )(turnoSaldadoDispatch);
      } else {
        wsGetTurnoSaldado(
          turno.idturno,
          stopLoopTurnoSaldado,
        )(turnoSaldadoDispatch);
      }
      // 36 son 3 minutos
      count++;
      if (count >= 36) {
        setAvisoAutocheck(true)(avisoAutocheckDispatch);
        clearInterval(interval);
        mercadoPagoReset()(mercadoPagoDispatch);
        setPaso("Home")(pasoDispatch);
      }
    }, 5000);
    return interval;
  };

  const verMediosDePago = () => {
    stopInterval();
    localStorage.removeItem("mercadoPago");
    setLoading(false);
  };

  const pagarEfectivo = () => {
    setMpReferencia(null);
    setPaso("EfectivoMP")(pasoDispatch);
  };

  const mountedRef = {
    current: true,
  };

  useEffect(() => {
    if (mercadoPagoState.mercadoPago.data) {
      setLoading(false);
      mercadoPagoReset()(mercadoPagoDispatch);
    }
  }, [loading]);

  const handleClickVolver = () => {
    if (pasoState.circuito === "labo") {
      setPaso("TurnosDelDiaLabo")(pasoDispatch);
    } else {
      setPaso("TurnosDelDia")(pasoDispatch);
    }
  };

  const stopInterval = () => {
    if (intervalID) {
      clearInterval(intervalID); // Detiene el intervalo
      setIntervalID(null); // Limpia el ID del intervalo
      setMpReferencia(null);
    }
  };
  //#endregion --------- funciones ---------------

  //#region  ----------- useEffect ---------------
  useEffect(() => {
    const isDesktopOrTablet =
      typeof window !== "undefined" && window.innerWidth >= 768;
    if (isDesktopOrTablet) return; // Desktop/Tablet usa flujo QR propio
    let interval;
    if (mpReferencia) {
      if (interval) {
        clearInterval(interval);
      }
      interval = loopTurnoSaldado();
    } else {
      if (turno?.idProtocolo > 0) {
        wsGetMercadoPagoLaboratorioQr(
          turno.idProtocolo,
          nextStepMercadoPago,
        )(mercadoPagoDispatch);
      } else {
        wsGetMercadoPagoTurnosQr(
          turno.idturno,
          nextStepMercadoPago,
        )(mercadoPagoDispatch);
      }
    }
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [mpReferencia]);

  // useEffect(() => {
  //   let interval;

  //   const iniciarLoop = () => {
  //     if (interval) clearInterval(interval);
  //     interval = loopTurnoSaldado();
  //     setIntervalID(interval); // si necesitás guardar el ID
  //   };

  //   if (flgLoop) {
  //     iniciarLoop();
  //   } else {
  //     if (turno?.idProtocolo > 0) {
  //       wsGetMercadoPagoLaboratorio(
  //         turno.idProtocolo,
  //         !paciente ? -1 : paciente.id,
  //         nextStepMercadoPago
  //       )(mercadoPagoDispatch);
  //     } else {
  //       wsGetMercadoPagoTurnos(
  //         turno.idturno,
  //         !paciente ? -1 : paciente.id,
  //         nextStepMercadoPago
  //       )(mercadoPagoDispatch);
  //     }
  //   }

  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === "visible") {
  //       iniciarLoop();
  //     }
  //   };

  //   document.addEventListener("visibilitychange", handleVisibilityChange);

  //   return () => {
  //     if (interval) {
  //       clearInterval(interval);
  //       document.removeEventListener(
  //         "visibilitychange",
  //         handleVisibilityChange
  //       );
  //     }
  //   };
  // }, [flgLoop]);

  useEffect(() => {
    const isDesktopOrTablet =
      typeof window !== "undefined" && window.innerWidth >= 768;
    wsGetTurnosPacienteDelDiaQr(refrescarTurnos)(turnosAutoCheckInDispatch);
    if (isDesktopOrTablet) return; // Desktop/Tablet no dispara generación aquí
    if (turno?.idProtocolo > 0) {
      wsGetMercadoPagoLaboratorioQr(
        turno.idProtocolo,
        nextStepMercadoPago,
      )(mercadoPagoDispatch);
    } else {
      wsGetMercadoPagoTurnosQr(
        turno.idturno,
        nextStepMercadoPago,
      )(mercadoPagoDispatch);
    }
  }, []);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);
  //#endregion  -------- useEffect ---------------

  return (
    <>
      <Loading
        dataLoading={loadingGral}
        color="c-white"
        descripcion={"Cargando..."}
      />
      {!loadingGral && (
        <LayoutPasos
          volverTo={"/autocheckin/resumen"}
          handleClick={() => {
            mercadoPagoReset()(mercadoPagoDispatch);
            handleClickVolver();
          }}
          type={"no-circle"}
          title={"Abonar MP"}
        >
          <CardBlueHeart
            medico={turno?.medico ? turno?.medico : turno?.especialidad}
            turnoTitle={turno?.especialidad}
            pasoActual={turnoActual + 1}
            pasoTotal={listTurnosSeleccionado.length}
          />
          <Paso4ContainerPaso>
            <PasoBar paso={"AbonarMP"} />
          </Paso4ContainerPaso>
          <Paso4Container>
            <Paso4Titulo>
              <span className={`${idTerminal ? "rb24m" : "rb18m"}`}>Pago</span>
            </Paso4Titulo>
            <hr className="ValidaTurno-separador"></hr>
            {loading ? (
              <>
                <div className={"loading-spinner-container"}>
                  <IonSpinner name="lines" />
                </div>
                <Paso4ContainerBotones>
                  <button
                    className="btn btn-validaturno btn-outline-validaturno bgc-white c-latex30 rb16m"
                    onClick={verMediosDePago}
                  >
                    Volver a medios de pago
                  </button>
                </Paso4ContainerBotones>
              </>
            ) : (
              <>
                <Paso4Body>
                  <span
                    className={`ValidaTurno-bodytxt ${idTerminal && "rb24t"}`}
                  >
                    {bodyTxt}
                  </span>
                  <div className="ValidaTurno-montoMercadoPago">
                    <span className="rb48m">${turno?.resumen?.monto}</span>
                  </div>
                  <span
                    className={`ValidaTurno-bodytxt ${idTerminal && "rb24t"}`}
                  >
                    {bodyTxt2}
                  </span>
                </Paso4Body>
                <Paso4ContainerBotones>
                  {idTerminal ? (
                    <>
                      <button
                        className="btn btn-validaturno btn-outline-validaturno bgc-white c-latex30"
                        onClick={handleClickMP}
                      >
                        <MercadoPagoLogo width={100} />
                      </button>
                      <button
                        className="btn btn-validaturno btn-outline-validaturno bgc-white c-latex30 rb16m"
                        onClick={pagarEfectivo}
                      >
                        Efectivo
                      </button>
                    </>
                  ) : mpReferencia !== null ? (
                    <>
                      <button
                        className="btn btn-validaturno btn-outline-validaturno bgc-white c-latex30"
                        onClick={handleClickMP}
                      >
                        <MercadoPagoLogo width={100} />
                      </button>
                      <button
                        className="btn btn-validaturno btn-outline-validaturno bgc-white c-latex30 rb16m"
                        onClick={pagarEfectivo}
                      >
                        Efectivo
                      </button>
                    </>
                  ) : (
                    <div className={"loading-spinner-container"}>
                      <IonSpinner name="lines" />
                    </div>
                  )}
                </Paso4ContainerBotones>
              </>
            )}
          </Paso4Container>
        </LayoutPasos>
      )}
    </>
  );
};

export default AbonarMP;
